import React from 'react';
import { Button, FormGroup, Input, Label } from '../../../../components/Bootstrap';
import { NobleModal } from '../../../../components';
import { MenuOption } from '../../types';

interface EditOptionModalProps {
  title: string;
  name: string;
  option: MenuOption;
  onCancel();
  onSubmit(option: MenuOption);
}

export class EditOptionModal extends React.Component<EditOptionModalProps, any> {
  constructor(props: EditOptionModalProps) {
    super(props);

    this.state = { price: props.option.price };
  }

  changePrice = (e) => {
    this.setState({
      price: e.target.value,
    });
  };

  onCancel = (e) => {
    e.preventDefault();
    this.props.onCancel();
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { price } = this.state;

    this.props.onSubmit({
      ...this.props.option,
      price: Number(price),
    });
  };

  render() {
    return (
      <NobleModal isOpen={true} toggle={this.props.onCancel}>
        <NobleModal.Title title={this.props.title} />
        <NobleModal.Body>
          <div className='option-modal-content'>
            <FormGroup>
              <Label className='text-right' for='option'>
                {this.props.name}
              </Label>
              <div>{this.props.option.option.name}</div>
            </FormGroup>
            <FormGroup>
              <Label className='text-right' for='price'>
                Upgrade Price
              </Label>
              <Input
                type='number'
                value={this.state.price}
                onChange={this.changePrice}
                name='number'
                id='price'
                placeholder='$0'
              />
            </FormGroup>
            <div className='text-center mt-4'>
              <Button type='button' color='link' onClick={this.onCancel}>
                Cancel
              </Button>{' '}
              <Button color='primary' onClick={this.onSubmit}>
                Save
              </Button>
            </div>
          </div>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
